<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "CategorySettingView"
}
</script>

<style scoped>

</style>